function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Loader } from '@domain-group/fe-blueprint-ui/loader';
import * as styles from './spinner.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Overlay = props => ___EmotionJSX("div", _extends({
  css: styles.overlay
}, props));
var Spinner = () => ___EmotionJSX(Overlay, {
  css: styles.spinner
}, ___EmotionJSX(Loader, null));
Spinner.Overlay = Overlay;
export default Spinner;